export const isSteloResolutionDetail = (resolutionDetail: string | undefined) =>
  resolutionDetail === 'LOW_ADVANCED_FRAUD_MODEL_SCORE';

export const isUserRejectedByDetail = (resolutionDetail: string | undefined) =>
  resolutionDetail &&
  ['INVALID_PERSONAL_DATA', 'LOW_IOVATION_SCORE', 'RISKY_TELEPHONE'].includes(
    resolutionDetail,
  );

export const isTinkRejectedByMessage = (
  resolutionMessage: string | undefined,
) =>
  resolutionMessage &&
  [
    'first_character_zero',
    'instantor_id_mismatch',
    'instantor_insufficient_transactions',
    'instantor_name_mismatch',
    'lc_tink_movements',
    'length_instantor',
    'tink_competitors_movements_2',
    'tink_competitors_movements_more_than_3',
    'tink_days&first&last&trans_trans6m_atm12m_rule1',
    'tink_days&first&last&trans_trans6m_atm12m_rule2',
    'tink_days&first&last&trans_trans6m_atm12m_rule3',
    'tink_days&first&last&trans_trans6m_atm12m_rule4',
    'tink_days&first&last&trans_trans6m_atm12m_rule5',
    'tink_days&first&last&trans_trans6m_atm12m_rule6',
    'tink_days_first_trans',
    'tink_days_last_trans',
  ].includes(resolutionMessage.toLowerCase());
